module.exports = __webpack_public_path__ + "img/team_julien_patrick_al-haug.cf25e4aa.webp";